module.exports = __webpack_public_path__ + "static/media/24.af718fd6.jpg";